/**
 * https://en.wikipedia.org/wiki/Standard_52-card_deck
 */
import debounce from "debounce";
import CardType from "../../models/card";

import "./styles.css";

interface Props {
  card: CardType;
  onClick?: () => void;
}

export default function Card({ card, onClick }: Props) {
  const clickable = typeof onClick === "function";
  const cardClass = [
    "card",
    "suit--" + card.suit.toLowerCase(),
    "face--" + card.action,
    clickable ? "clickable" : "",
  ];

  /* Debounce the onClick to avoid multiple rapid clicks */
  const handleOnClick = debounce(
    () => {
      if (typeof onClick === "function") {
        onClick();
      }
    },
    2000,
    { immediate: true },
  );

  return (
    <div id={card.id} className={cardClass.join(" ")}>
      {clickable ? (
        <button className="card-label" onClick={handleOnClick}>
          <span className="sr-only">{`${card.suit} ${card.action}`}</span>
        </button>
      ) : (
        <span className="sr-only">{`${card.suit} ${card.action}`}</span>
      )}
      <div className="face-top">
        <span>{card.face}</span>
      </div>
      <div className="face">
        <span>{card.face}</span>
      </div>
      <div className="face-bottom">
        <span>{card.face}</span>
      </div>
    </div>
  );
}
